import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { selectHazardAttrById } from '../constants/hazardAttrs';
import { fetchEpisodesData, fetchCountyNames } from './episodes.utils';

export const getEpisodesDataAsync = createAsyncThunk(
  'episodes/getEpisodesData',
  async (arg, { getState, requestId }) => {
    const { currentRequestId, loading, year } =
      getState().episodes;
    const { hazardOption } = getState().options;

    let episodesData = {
      year,
      episodesData: {},
      countyNames: {},
    };

    let name = selectHazardAttrById(hazardOption).name;

    if (arg.type === 'changeYear') {
      episodesData.year = arg.payload[0];
    } else if (arg.type === 'changeAttribute' && year) {
      name = selectHazardAttrById(arg.payload).name;
    } else {
      return episodesData;
    }

    if (loading && requestId === currentRequestId) {
      const newepisodesData = await fetchEpisodesData(name, episodesData.year);
      episodesData.episodesData = newepisodesData;

      const fips = [];
      for (const id in newepisodesData) {
        newepisodesData[id].events.forEach((event) => {
          event.counties.forEach((fip) => {
            if (!fips.includes(fip)) fips.push(fip);
          });
        });
      }
      episodesData.countyNames = await fetchCountyNames(fips);
    }
    return episodesData;
  }
);

const initialState = {
  loading: false,
  currentRequestId: undefined,
  year: null,
  episodesData: {},
  countyNames: {},
  selectedEpisodeEvents: { events: [], date: '' },
};

const episodesSlice = createSlice({
  name: 'episodes',
  initialState,
  reducers: {
    changeSelectedEpisodeEvents(state, action) {
      state.selectedEpisodeEvents = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEpisodesDataAsync.pending, (state, action) => {
        if (!state.loading) {
          state.loading = true;
          state.currentRequestId = action.meta.requestId;
        }
      })
      .addCase(getEpisodesDataAsync.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.year = action.payload.year;
          state.episodesData = action.payload.episodesData;
          state.countyNames = action.payload.countyNames;
          state.loading = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(getEpisodesDataAsync.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.year = null;
          state.episodesData = {};
          state.countyNames = {};
          state.selectedEpisodeEvents = { events: [], date: '' };
          state.loading = false;
          alert(
            'An error has occurred fetching episodes data. The data being shown may not be accurate.'
          );
          state.currentRequestId = undefined;
        }
      });
  },
});

export const { changeSelectedEpisodeEvents } = episodesSlice.actions;
export default episodesSlice.reducer;
